/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { ParsedToken } from 'firebase/auth';
import { UserType } from '../context/AuthContext/User.types';

export interface AuthSlice {
  appEnvId: string,
  appId: string,
  authorized: boolean,
  authToken: string,
  authUrl: string,
  canAccessEnvironment: boolean | undefined,
  claims: ParsedToken,
  currentUser: UserType,
  enableAppEnvironment: boolean,
  loadingCurrentUser: boolean,
  loginError: string,
  userPermissions: [],
  redirectUrl: string,
}

/**
 * Auth Reducer Specs
 */
export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    appEnvId: undefined,
    appId: `${process.env.REACT_APP_ID}`,
    authorized: false,
    authToken: undefined,
    authUrl: `${process.env.REACT_APP_AUTH_EXPRESS_URL}`,
    canAccessEnvironment: undefined,
    claims: [],
    currentUser: undefined,
    enableAppEnvironment: `${process.env.REACT_APP_ENABLE_APP_ENVIRONMENT}` === 'true',
    loadingCurrentUser: true,
    loginError: undefined,
    userPermissions: undefined,
    redirectUrl: undefined,
  },
  reducers: {
    resetAuthToken: (state) => { state.authToken = undefined; },
    resetClaims: (state) => { state.claims = []; },
    resetCurrentUser: (state) => { state.currentUser = undefined; },
    // @ts-ignore
    setAppEnvId: (state, action: PayloadAction<string | undefined>) => { state.appEnvId = action.payload; },
    // @ts-ignore
    setAuthorized: (state) => { state.authorized = true; },
    // @ts-ignore
    setAuthToken: (state, action: PayloadAction<string>) => { state.authToken = action.payload; },
    // @ts-ignore
    setCurrentUser: (state, action: PayloadAction<UserType>) => { state.currentUser = action.payload; },
    // @ts-ignore
    setClaims: (state, action: PayloadAction<ParsedToken>) => { state.claims = action.payload; },
    setLoadingCurrentUser: (state, action: PayloadAction<boolean>) => { state.loadingCurrentUser = action.payload; },
    setUnauthorized: (state) => { state.authorized = false; },
    // @ts-ignore
    setCanAccessEnvironment: (state, action: PayloadAction<boolean>) => { state.canAccessEnvironment = action.payload; },
    // @ts-ignore
    setUserPermissions: (state, action: PayloadAction<[]>) => { state.userPermissions = action.payload; },
    // @ts-ignore
    setLoginError: (state, action: PayloadAction<string | undefined>) => { state.loginError = action.payload; },
    // @ts-ignore
    setRedirectUrl: (state, action: PayloadAction<string | undefined>) => { state.redirectUrl = action.payload; },
  },
});

export const {
  resetAuthToken,
  resetClaims,
  resetCurrentUser,
  setAppEnvId,
  setAuthorized,
  setAuthToken,
  setCanAccessEnvironment,
  setClaims,
  setCurrentUser,
  setLoadingCurrentUser,
  setLoginError,
  setUnauthorized,
  setUserPermissions,
  setRedirectUrl,
} = authSlice.actions;

export default authSlice.reducer;
